import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusLabelComponent } from '@principle-theorem/ng-principle-shared';
import {
  type PartnerStatus,
  PARTNER_STATUS_MAP,
} from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-partner-status',
  templateUrl: './partner-status.component.html',
  styleUrls: ['./partner-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatusLabelComponent],
})
export class PartnerStatusComponent {
  @Input() status: PartnerStatus;
  @Input({ transform: coerceBooleanProperty }) dense = false;
  statusColourMap: {
    [key in PartnerStatus]: string;
  } = PARTNER_STATUS_MAP;
}
